import React from 'react';
import { Link } from 'react-router-dom';
const footerData = [{
  title: 'Platform',
  links: [{
    label: 'Platform Overview',
    to: '/platform'
  }, {
    label: 'Breach and Attack Simulation',
    to: '/breach-and-attack-simulation'
  }, {
    label: 'Exposure Validation',
    to: '/platform/exposure-validation'
  }, {
    label: 'Automated Penetration Testing',
    to: '/platform/automated-penetration-testing'
  }, {
    label: 'Picus Swarm',
    to: '/platform/picus-swarm'
  }, {
    label: 'Integrations',
    to: '/integrations'
  }, {
    label: 'Picus vs. Alternatives',
    to: '/platform/picus-vs-alternatives'
  }]
}, {
  title: 'Use Cases',
  links: [{
    label: 'Emerging Threat Response',
    to: '/use-cases/emerging-threat-response'
  }, {
    label: 'Validate Security Controls',
    to: '/use-cases/validate-security-controls'
  }, {
    label: 'Validate Detection Rules',
    to: '/use-cases/validate-detection-rules'
  }, {
    label: 'Prioritize Real Exposure',
    to: '/use-cases/prioritize-real-exposure'
  }, {
    label: 'Reduce Manual Overhead',
    to: '/use-cases/reduce-manual-triage'
  }, {
    label: 'Accelerate Remediation',
    to: '/use-cases/accelerate-remediation'
  }, {
    label: 'Prove Compliance',
    to: '/use-cases/prove-compliance'
  }, {
    label: 'Validate AI Security',
    to: '/use-cases/ai-security-validation'
  }, {
    label: 'Prove Readiness',
    to: '/use-cases/prove-readiness'
  }, {
    label: 'Automate Penetration Testing',
    to: '/use-cases/automate-penetration-testing'
  }]
}, {
  title: 'Industries',
  links: [{
    label: 'Financial Services',
    to: '/industries/financial-services'
  }, {
    label: 'Healthcare',
    to: '/industries/healthcare'
  }, {
    label: 'IT / OT',
    to: '/industries/it-ot'
  }, {
    label: 'Critical Infrastructure',
    to: '/industries/critical-infrastructure'
  }, {
    label: 'Manufacturing',
    to: '/industries/manufacturing'
  }, {
    label: 'Retail / eCommerce',
    to: '/industries/retail-ecommerce'
  }, {
    label: 'Public Sector',
    to: '/industries/public-sector'
  }, {
    label: 'Technology / SaaS',
    to: '/industries/technology-saas'
  }]
}, {
  title: 'Frameworks & Compliance',
  links: [{
    label: 'CTEM',
    to: '/frameworks-and-compliance/ctem'
  }, {
    label: 'MITRE ATT&CK',
    to: '/frameworks-and-compliance/mitre-attack'
  }, {
    label: 'NIST CSF',
    to: '/frameworks-and-compliance/nist-csf'
  }, {
    label: 'HIPAA',
    to: '/frameworks-and-compliance/hipaa'
  }, {
    label: 'PCI DSS',
    to: '/frameworks-and-compliance/pci-dss'
  }, {
    label: 'DORA',
    to: '/frameworks-and-compliance/dora'
  }, {
    label: 'NIS2',
    to: '/frameworks-and-compliance/nis2'
  }, {
    label: 'ASEAN Cyber',
    to: '/frameworks-and-compliance/asean-cyber'
  }, {
    label: 'MAS TRM',
    to: '/frameworks-and-compliance/mas-trm'
  }]
}, {
  title: 'Research & Resources',
  links: [{
    label: 'Red Report',
    to: '/research/red-report'
  }, {
    label: 'Blue Report',
    to: '/research/blue-report'
  }, {
    label: 'Purple Academy',
    to: '/resources/purple-academy'
  }, {
    label: 'Threat Response Index',
    to: '/research/threat-response-index'
  }, {
    label: 'Picus Labs',
    to: '/research/picus-labs'
  }, {
    label: 'Emerging Threats',
    to: '/research/emerging-threats'
  }, {
    label: 'Blogs',
    to: '/resources/blogs'
  }, {
    label: 'Glossary',
    to: '/resources/glossary'
  }, {
    label: 'Events',
    to: '/resources/events'
  }, {
    label: 'All Resources',
    to: '/resources'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'About',
    to: '/company/about'
  }, {
    label: 'Customers',
    to: '/company/customers'
  }, {
    label: 'Partners',
    to: '/company/partners'
  }, {
    label: 'Careers',
    to: '/company/careers'
  }, {
    label: 'Contact',
    to: '/contact'
  }]
}];
export function Footer() {
  return <footer className="bg-picus-surface border-t border-picus-border pt-[96px] pb-[64px]" data-id="element-155">
      <div className="max-w-[1280px] mx-auto px-[36px]" data-id="element-156">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-24" data-id="element-157">
          {footerData.map((col, idx) => <div key={idx} data-id="element-158">
              <h4 className="font-mono text-[12px] leading-[16px] font-bold uppercase tracking-[2.4px] text-white mb-8" data-id="element-159">
                {col.title}
              </h4>
              <ul className="space-y-4" data-id="element-160">
                {col.links.map((link, linkIdx) => <li key={linkIdx} data-id="element-161">
                    <Link to={link.to} className="font-mono text-[12px] leading-[16px] font-normal uppercase tracking-[2.4px] text-picus-muted hover:text-picus-accent transition-colors block" data-id="element-162">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="border-t border-picus-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-163">
          <div className="font-mono text-[12px] leading-[16px] font-normal uppercase tracking-[2.4px] text-picus-muted" data-id="element-164">
            &copy; {new Date().getFullYear()} Picus Security
          </div>
          <Link to="/" className="flex-shrink-0" data-id="element-165">
            <img src="https://www.picussecurity.com/hubfs/light_logo-original-SVG.svg" alt="Picus Security" className="h-6" data-id="element-166" />
          </Link>
        </div>
      </div>
    </footer>;
}